import { Action } from '@zaibot/fsa';

export default Action<{}>('ADDRESSEE_LOADED');



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/questionaddressee/actions/ADDRESSEE_LOADED.tsx